/* eslint-disable react-hooks/exhaustive-deps */
// Routes for mapping link
import React from 'react';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import StyleDetail from 'containers/style_detail/style_detail';
import { lazyRetry } from 'features/router';
import { lazy, Suspense, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { Redirect, Route, Switch } from 'react-router-dom';
import PrivateRouteCustomer from 'routes/private_customer_route';
import ErrorPage from '../containers/error/ErrorPage';
import { PATH } from './constant';
import DashboardRouter from './DashboardRouter';
import DesktopRoute from './DesktopRoute';
import { PATH_ANONYMOUS, PATH_CUSTOMER, PATH_GLOBAL, PATH_STYLIST } from './path';
import PrivateRoute from './private_route';
import PrivateRouteStylist from './private_stylist_route';
import PrivateRouteAnonymous from './private_anonymous_route';
import ProfileRoute from './ProfileRoute';
import StoreProvider from './StoreProvider';
import { RecommendStylePage } from 'pages/RecommendStylePage';

const Routing = () => {
    const HomeCustomer = lazy(() =>
        lazyRetry(
            () => import('containers/homeScreen/home_customer/index'),
            'containers/homeScreen/home_customer/index',
        ),
    );
    const IntroTaffi = lazy(() =>
        lazyRetry(() => import('containers/intro_taffi/index'), 'containers/intro_taffi/index'),
    );
    const CreateNewPassword = lazy(() =>
        lazyRetry(
            () => import('containers/authentication/forgot_password/create_new_password'),
            'containers/authentication/forgot_password/create_new_password',
        ),
    );
    const ProfileCustomer = lazy(() =>
        lazyRetry(() => import('containers/profile_customer/index'), 'containers/profile_customer/index'),
    );
    const MyStylePreferences = lazy(() =>
        lazyRetry(
            () => import('containers/profile_customer/view_profile_customer/style_preferences/index'),
            'containers/profile_customer/view_profile_customer/style_preferences/index',
        ),
    );
    const Notifications = lazy(() =>
        lazyRetry(() => import('containers/notification/index'), 'containers/notification/index'),
    );
    const PersonalProfile = lazy(() =>
        lazyRetry(
            () => import('containers/profile_customer/personal_profile'),
            'containers/profile_customer/personal_profile',
        ),
    );
    const MyWardrobe = lazy(() =>
        lazyRetry(() => import('containers/profile_customer/MyWardrobe'), 'containers/profile_customer/MyWardrobe'),
    );
    const CreateItem = lazy(() => lazyRetry(() => import('containers/create-item'), 'containers/create-item'));
    const ViewStylistProfile = lazy(() =>
        lazyRetry(() => import('containers/view_stylist_profile/index'), 'containers/view_stylist_profile/index'),
    );
    const CustomerStyleGuide = lazy(() =>
        lazyRetry(() => import('containers/customer_style_guide'), 'containers/customer_style_guide'),
    );
    const StylesRequestContainer = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/personas/style_request'),
            'containers/quiz_manager/personas/style_request',
        ),
    );
    const StylesQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/style_quiz/style_quiz'),
            'containers/quiz_manager/style_quiz/style_quiz',
        ),
    );
    const BudgetQuiz = lazy(() =>
        lazyRetry(() => import('containers/quiz_manager/budget_quiz'), 'containers/quiz_manager/budget_quiz'),
    );
    const BodyShapeQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/body_shape_body_type/body_shape_quiz'),
            'containers/quiz_manager/body_shape_body_type/body_shape_quiz',
        ),
    );
    const BodyTypeQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/body_shape_body_type/body_type_quiz'),
            'containers/quiz_manager/body_shape_body_type/body_type_quiz',
        ),
    );
    const MyBirthDayQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/my_birthday/my_birthday'),
            'containers/quiz_manager/my_birthday/my_birthday',
        ),
    );
    const SkinToneQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/color_list_multi/skin_tone'),
            'containers/quiz_manager/color_list_multi/skin_tone',
        ),
    );
    const ColorQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/color_quiz/color_quiz'),
            'containers/quiz_manager/color_quiz/color_quiz',
        ),
    );
    const SizesQuiz = lazy(() =>
        lazyRetry(() => import('containers/quiz_manager/size_list/sizes'), 'containers/quiz_manager/size_list/sizes'),
    );

    const SkinUndertoneQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/skin_undertone/SkinUndertone'),
            'containers/quiz_manager/skin_undertone/SkinUndertone',
        ),
    );
    const HairColorQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/hair_color/HairColor'),
            'containers/quiz_manager/hair_color/HairColor',
        ),
    );
    const MyPhotos = lazy(() =>
        lazyRetry(
            () => import('containers/quiz_manager/my_photos/my_photos'),
            'containers/quiz_manager/my_photos/my_photos',
        ),
    );
    const SizeListQuiz = lazy(() =>
        lazyRetry(() => import('containers/quiz_manager/size_list/sizes'), 'containers/quiz_manager/size_list/sizes'),
    );

    const HijabQuiz = lazy(() =>
        lazyRetry(() => import('containers/quiz_manager/hijab/HijabQuiz'), 'containers/quiz_manager/hijab/HijabQuiz'),
    );

    const OrderListing = lazy(() => lazyRetry(() => import('containers/oder_listing'), 'containers/oder_listing'));
    const OrderDetail = lazy(() => lazyRetry(() => import('containers/order_detail'), 'containers/order_detail'));
    const UserReactions = lazy(() => lazyRetry(() => import('containers/user_reactions'), 'containers/user_reactions'));
    const MySessions = lazy(() => lazyRetry(() => import('containers/my_sessions'), 'containers/my_sessions'));
    const SessionDetails = lazy(() =>
        lazyRetry(() => import('containers/session_details'), 'containers/session_details'),
    );
    const RedirectToSessionDetails = lazy(() =>
        lazyRetry(
            () => import('containers/redirects/RedirectToSessionDetails'),
            'containers/redirects/RedirectToSessionDetails',
        ),
    );
    const RedirectToProfile = lazy(() =>
        lazyRetry(() => import('containers/redirects/RedirectToProfile'), 'containers/redirects/RedirectToProfile'),
    );
    const ItemsToShop = lazy(() =>
        lazyRetry(
            () => import('containers/profile_customer/item_to_shop/index'),
            'containers/profile_customer/item_to_shop/index',
        ),
    );
    const ViewconsumerRequestQuiz = lazy(() =>
        lazyRetry(
            () => import('containers/session_quiz/view_session_quiz'),
            'containers/session_quiz/view_session_quiz',
        ),
    );

    const BecomeAnAnonymous = lazy(() =>
        lazyRetry(
            () => import('containers/authentication/SignUp/become_an_anonymous'),
            'containers/authentication/SignUp/become_an_anonymous',
        ),
    );
    const ChatScreen = lazy(() => lazyRetry(() => import('containers/chat/index'), 'containers/chat/index'));
    const isMobileCheck = JSON.parse(sessionStorage?.getItem('isMobile') || JSON.stringify(isMobile));

    const PdpStyleWidget = lazy(() =>
        lazyRetry(() => import('containers/style_widget/Pdp_style_widget'), 'container/style_widget/Pdp_style_widget'),
    );
    const RedirectSharePath = lazy(() =>
        lazyRetry(() => import('containers/redirects/RedirectSharePath'), 'containers/redirects/RedirectSharePath'),
    );

    useEffect(() => {
        if (!isMobileCheck) {
            sessionStorage.setItem('isMobile', JSON.stringify(isMobile));
        }
    }, []);

    return (
        <Suspense fallback={<LoadingDataSpinner />}>
            <StoreProvider>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => {
                            return (
                                <Redirect
                                    to={{
                                        pathname: PATH.HOME,
                                        state: { isRedirect: true },
                                    }}
                                />
                            );
                        }}
                    />
                    <Route path={PATH.PDP_WIDGET} component={PdpStyleWidget} />
                    <Route exact path={PATH.INTRO} component={IntroTaffi} />
                    <Route path={PATH.CREATE_NEW_PASSWORD} component={CreateNewPassword} />
                    <Route path={`${PATH.STYLE_DETAIL}/:taffiId`} component={StyleDetail} />
                    <Route path={`${PATH.ITEM_DETAIL}/:taffiId`} component={StyleDetail} />
                    <Route path={PATH.DISCOVER_YOUR_STYLE} component={RecommendStylePage} />
                    <Route path={PATH.STYLE_IT_RIGHT} component={RecommendStylePage} />
                    <Route
                        path={PATH.INTRO}
                        render={() => {
                            return <Redirect to={isMobileCheck ? PATH.LOGIN : PATH.INTRO} />;
                        }}
                    />

                    <Route path={PATH.SHARE} component={RedirectSharePath} />

                    {PATH_GLOBAL.map((route, i) => (
                        <DesktopRoute key={i} {...route} />
                    ))}
                    <Route path={PATH.SIGNUP_ANONYMOUS_CUSTOMER} component={BecomeAnAnonymous} />
                    <DashboardRouter exact path={PATH.HOME} component={HomeCustomer} />
                    <ProfileRoute exact path={PATH.PROFILE} component={ProfileCustomer} />
                    <PrivateRoute path={PATH.MY_STYLE_PREFERENCES} component={MyStylePreferences} />
                    <PrivateRoute path={PATH.NOTIFICATIONS} component={Notifications} />
                    <PrivateRouteStylist path={`${PATH.CONSUMER_PROFILE_INFO}/:userName`} component={PersonalProfile} />
                    <PrivateRoute path={PATH.PROFILE_INFO} component={PersonalProfile} />
                    <PrivateRoute path={PATH.OLD_PROFILE_INFO} component={RedirectToProfile} />
                    <PrivateRoute path={`${PATH.CONSUMER_WARDROBE}/:userName`} component={MyWardrobe} />
                    <PrivateRoute path={`${PATH.CREATE_ITEM}`} component={CreateItem} />
                    <PrivateRoute path={`${PATH.EDIT_ITEM}/:taffiId`} component={CreateItem} />
                    <PrivateRoute path={`${PATH.STYLIST_PROFILE}/:userName`} component={ViewStylistProfile} />
                    <PrivateRouteStylist
                        path={`${PATH.CONSUMER_STYLE_GUIDE}/:userName`}
                        component={CustomerStyleGuide}
                    />
                    <PrivateRouteStylist path={`${PATH.QUIZ_PERSONAS}/:userName`} component={StylesRequestContainer} />
                    <PrivateRouteStylist path={`${PATH.STYLE_QUIZ}/:userName`} component={StylesQuiz} />
                    <PrivateRouteStylist path={`${PATH.BUDGET_QUIZ}/:userName`} component={BudgetQuiz} />
                    <PrivateRouteStylist path={`${PATH.CONSUMER_PHOTOS}/:userName`} component={MyPhotos} />
                    <PrivateRouteStylist path={`${PATH.BODY_SHAPE_QUIZ}/:userName`} component={BodyShapeQuiz} />
                    <PrivateRouteStylist path={`${PATH.BODY_TYPE_QUIZ}/:userName`} component={BodyTypeQuiz} />
                    <PrivateRouteStylist path={`${PATH.MY_BIRTHDAY_QUIZ}/:userName`} component={MyBirthDayQuiz} />
                    <PrivateRouteStylist path={`${PATH.SKIN_TONE}/:userName`} component={SkinToneQuiz} />
                    <PrivateRouteStylist path={`${PATH.COLOR_QUIZ}/:userName`} component={ColorQuiz} />
                    <PrivateRouteStylist path={`${PATH.SIZES_QUIZ}/:userName`} component={SizesQuiz} />
                    <PrivateRouteStylist path={`${PATH.SKIN_UNDERTONE}/:userName`} component={SkinUndertoneQuiz} />
                    <PrivateRouteStylist path={`${PATH.HAIR_COLOR}/:userName`} component={HairColorQuiz} />
                    <PrivateRouteStylist path={`${PATH.SIZES_QUIZ}/:userName`} component={SizeListQuiz} />
                    <PrivateRouteStylist path={`${PATH.HIJAB_QUIZ}/:userName`} component={HijabQuiz} />
                    <PrivateRouteStylist path={`${PATH.CONSUMER_ORDERS}/:userName`} component={OrderListing} />
                    <PrivateRouteStylist path={`${PATH.ODER_DETAIL}/:userName/:orderTaffiId`} component={OrderDetail} />
                    <PrivateRouteStylist path={`${PATH.USER_LIKES}/:userName`} component={UserReactions} />
                    <PrivateRouteStylist path={`${PATH.USER_DISLIKES}/:userName`} component={UserReactions} />
                    <PrivateRouteStylist path={`${PATH.CONSUMER_ITEMS_TO_SHOP}/:userName`} component={ItemsToShop} />
                    <PrivateRouteStylist path={`${PATH.STYLE_ASSISTANT}/:userName`} component={ChatScreen} />
                    <PrivateRouteStylist
                        path={`${PATH.STYLE_REQUEST_QUIZ}/:userName`}
                        component={ViewconsumerRequestQuiz}
                    />
                    <PrivateRoute path={`${PATH.MY_STYLE_REQUESTS}`} component={MySessions} />
                    <PrivateRoute path={`${PATH.STYLE_REQUEST}/:taffiId`} component={SessionDetails} />
                    <PrivateRoute path={`${PATH.OLD_SESSION_DETAIL}/:taffiId`} component={RedirectToSessionDetails} />
                    <PrivateRoute path={`${PATH.OLD_SESSION_DETAIL2}/:taffiId`} component={RedirectToSessionDetails} />

                    {PATH_CUSTOMER.map((route, i) => (
                        <PrivateRouteCustomer key={i} {...route} />
                    ))}
                    {PATH_STYLIST.map((route, i) => (
                        <PrivateRouteStylist key={i} {...route} />
                    ))}
                    {PATH_ANONYMOUS.map((route, i) => (
                        <PrivateRouteAnonymous key={i} {...route} />
                    ))}
                    <Route
                        exact
                        path={PATH.SERVER_ERROR}
                        render={() => {
                            return <ErrorPage type={500} />;
                        }}
                    />
                    <Route
                        path="*"
                        render={() => {
                            return <ErrorPage type={404} />;
                        }}
                    />
                </Switch>
            </StoreProvider>
        </Suspense>
    );
};
export const MainRouting = React.memo(Routing);
